export default __webpack_public_path__ + "static/media/about_photo.7870154f.jpg";